<template>
    <div id="content" v-show="!loading">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction"></popup>
        <form>
            <div class="inner">
              <p class="paging">
                  <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
              </p>
              <p class="buttons" v-if="isEditable">
                <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
                  @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
              </p>
              <h1 v-if="entity.name">{{ entity.name }}</h1>
            </div>

            <div class="responsiveTabs">
              <div class="tabs_content">
                <section v-show="$_readActionAllowedAllOrOwnAndGlobal">
                  <div class="left">
                    <h2 v-translate>Výběr operátora</h2>
                  </div>
                  <div class="right">
                    <div class="field_left">
                      <operator-select
                          v-model="operatorIdComputed"
                          :options="operatorOptions"
                          :disabled="true"
                      >
                      </operator-select>
                    </div>
                  </div>
                </section>
                <section>
                  <div class="left">
                    <detail-entity-info
                    :entity="entity"
                    ></detail-entity-info>
                  </div>
                  <service-weight-category-basic-form
                    :entity="entity"
                    :is-editable.sync="isEditable"
                    ref="serviceweightcategoryformref"
                  />
                </section>
                <section class="buttons" v-if="isEditable">
                    <p>
                        <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
                        </router-link>
                        <input type="submit" :value="'Uložit' | translate"
                               :class="['btn']"
                               @click.prevent.stop="submitForm()">
                    </p>
                </section>
              </div>
            </div>
        </form>
    </div>
</template>

<script>
	import ServiceWeightCategoryBasicForm from "@/components/views/serviceWeightCategories/forms/ServiceWeightCategoryBasicForm"
	import detailActions from "@/components/mixins/detail-actions"
	import serviceWeightCategories from "@/components/views/serviceWeightCategories/mixins/serviceWeightCategories"
  import DetailEntityInfo from "../../common/DetailEntityInfo";

	export default {
		name: "ServiceWeightCategoryDetail",
		components: {DetailEntityInfo, ServiceWeightCategoryBasicForm},
		mixins: [detailActions, serviceWeightCategories],
		created(ServiceWeightCategoryService, OperatorService) {
			this.entityService = ServiceWeightCategoryService

      if (this.$_readActionAllowedAllOrOwnAndGlobal) {
        this.operatorService = OperatorService
        this.getOperators(true)
      }

			this.createdInit()
		},
    computed: {
      isEditable() {
        return this.entity.value !== 0 && this.$_updateActionAllowed;
      },
    },
		methods: {
			getEntity() {
				this.setLoadingMessage()

				return this.entityService.getEntity(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
					.then(data => {
						this.entity = data.serviceWeightCategory
						this.emptyMessage()
					})
					.then(() => {
						this.$refs['serviceweightcategorybasicform'].validateServiceWeightCategoryFormRequiredFields()
					})
					.catch(function (error) {
						this.setErrorMessage(error['error_message'])
					}.bind(this))
			},
			updateEntity(params, redirect = false) {
				this.entityService.updateEntity(this.entity.id, this.filterFormParams({...params}))
					.then(() => {
						if (redirect === true) {
							this.redirect(this.moduleName)
						} else {
							this.emptyMessage()
							this.getEntity().then(() => {
                this.setSuccessMessage()
              })
						}
					})
					.catch(function (error) {
						this.setErrorMessage(this.processErrorMessage(error))
					}.bind(this))
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/serviceWeightCategories/ServiceWeightCategoryDetail.vue